// Loading, error and empty states. Every screen uses these so nothing is ever blank.

import type { ReactNode } from 'react';
import { errorMessage } from '../api';

export function Loading({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="center">
      <span className="spinner" aria-hidden="true" />
      <span style={{ marginLeft: 8 }}>{label}</span>
    </div>
  );
}

export function ErrorBox({ error, retry }: { error: unknown; retry?: () => void }) {
  return (
    <div className="notice danger" role="alert">
      {errorMessage(error)}
      {retry && (
        <>
          {' '}
          <button className="btn link" onClick={retry}>
            Try again
          </button>
        </>
      )}
    </div>
  );
}

export function Empty({ title, hint, children }: { title: string; hint?: string; children?: ReactNode }) {
  return (
    <div className="empty">
      <strong>{title}</strong>
      {hint && <div>{hint}</div>}
      {children && <div style={{ marginTop: 10 }}>{children}</div>}
    </div>
  );
}

export function InlineError({ error }: { error: unknown }) {
  if (!error) return null;
  return (
    <div className="danger-text small" role="alert">
      {errorMessage(error)}
    </div>
  );
}
